import { Button } from "@mui/material";

interface IProps {
  title: string;
  handleOpenModal: any;
  width?: string;
  height?: string;
  fontSize?: string;
  disabled?: boolean
}

const ToolbarButton = ({ title, handleOpenModal, height, width, fontSize, disabled }: IProps) => {
  return (
    <Button
      color="secondary"
      disabled={disabled}
      onClick={handleOpenModal}
      variant="contained"
      sx={{
        height: height || "36px",
        fontSize: "16px",
        textTransform: "none",
        bgcolor: "#0055A8",
        ":hover": {
          bgcolor: "primary.main",
        },
        ...(width && { width: width }),
      }}
    >
      {title}
    </Button>

  );
};

export default ToolbarButton;
